module.exports = __webpack_public_path__ + "static/media/SDGIcons_3.ca927957.png";